import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';
import { ListModule } from '../list/list.module';
import { MenuItemModule } from './menu-item.module';

import { ModalModule } from '../modal/modal.module';
import { ModalHeaderModule } from '../modal/modal-header.module';
import { ModalContentModule } from '../modal/modal-content.module';

@NgModule({
  declarations: [MenuComponent],
  imports: [CommonModule, ButtonModule, IconModule, ListModule, MenuItemModule, ModalModule, ModalHeaderModule, ModalContentModule],
  exports: [MenuComponent],
})
export class MenuModule {}
